import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FileText } from 'lucide-react';

export function ProspectsList() {
  return (
    <Box sx={{ textAlign: 'center', py: 6 }}>
      <Box sx={{ mx: 'auto', color: 'text.disabled' }}>
        <FileText size={48} />
      </Box>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mt: 1 }}>
        Prospects Coming Soon
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Prospect management will be available in a future release.
      </Typography>
    </Box>
  );
}
